import React from "react";
import {Box, Chip, Icon, Tooltip} from "@mui/material";
import {GraphQlDataGrid, nestedValueGetter} from "../../../../components/common/grid/GraphQlDataGrid";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GridFilterItem} from "@mui/x-data-grid/models/gridFilterItem";
import gqlGetClaimLookup from "../graphql/queries/gqlGetClaimLookup";
import {GridRenderCellParams} from "@mui/x-data-grid";
import moment from "moment/moment";
import {LocalHospital} from "@mui/icons-material";
import {translateFunction} from "../../../../localization/TranslationService";
const translate = translateFunction("SureBaseDocuments");


interface IClaimLookup {
	onRowClick?: (row: any) => void;
	defaultFilter?: GridFilterItem[];
	autoSelectSingleRecord?: boolean;
}

const defaultFilter = [
	{
		field: "claim.schadenr",
		operator: "equals",

	},
	{
		field: "claim.cedschadenr",
		operator: "equals",
	},

	{
		field: "customer.id",
		operator: "startsWith",
	},
	{
		field: "customer.naam",
		operator: "startsWith",
	},
	{
		field: "customer.plaats",
		operator: "startsWith",
	},
	{
		field: "customer.postcode",
		operator: "startsWith",
	},
	{
		field: "policy.nr",
		operator: "equals",
	},
	{
		field: "policy.kenteken",
		operator: "equals",
	},
];

export const ClaimLookup: React.FC<IClaimLookup> = (props) => {
	const filter = defaultFilter.filter((it) => props.defaultFilter &&  (props.defaultFilter.filter((x) => x.field === it.field  ).length === 0));

	return (
		<Box>
			<GraphQlDataGrid
				enableHeaderFilter
				hideExportButton
				client={graphQLServices.documentsClient}
				query={
					gqlGetClaimLookup
				}
				defaultSortModel={[
					{
						field: "claim.schadenr",
						sort: "desc"
					}
				]}
				defaultFilterModel={{
					items: [...filter??[],...props.defaultFilter??[]]
				}}

				columns={[
					{
						field: "claim.letselSchade",
						headerName: translate("Injury"),
						valueGetter: nestedValueGetter,
						width: 80,
						sortable: false,
						filterable: false,
						type: "string",
						renderCell: (params) => {
							return (
								<>
									{(params.row.claim.letselschade === "J") && <Tooltip title={translate("Injury")}><LocalHospital color="error"/></Tooltip>}
									{(params.row.claim.letselschade !== "J") && <Tooltip title={translate("Injury")}><Icon/></Tooltip>}
								</>
							);
						},
					},
					
					{
						field: "claim.swAfgehandeld",
						headerName: "Status",

						valueGetter: nestedValueGetter,
						width: 150,
						sortable: false,
						type: "boolean",
						renderCell: (params) => {
							return  params.value ? (
								<Chip label="Afgehandeld" />
							): (<></>);
						},
						filterable: false,

					},
					{
						field: "claim.id",
						headerName: "Id",
						valueGetter: nestedValueGetter,
						width: 150,
						sortable: true,
					},

					{
						field: "claim.schadenr",
						headerName: "Schadenr",
						valueGetter: nestedValueGetter,
						width: 150,
						sortable: true,
						type: "number",
						align: "left",
						valueFormatter: (params => `${params.value}`)
					},
					{
						field: "claim.cedSchadenr",
						headerName: "CED nr",
						valueGetter: nestedValueGetter,
						//filterIgnoreCase: false,
						width: 150,
						sortable: true,
					},
					{
						field: "claim.aanmelddatum",
						headerName: "Aangemeld",
						valueGetter: nestedValueGetter,
						//filterIgnoreCase: false,
						width: 150,
						sortable: false,
						filterable: false,
						renderCell: (params: GridRenderCellParams) => {
							return (
								<>
									{params.row.claim.aanmelddatum &&
										moment(params.row.claim.aanmelddatum).format("DD-MM-YYYY")}
								</>
							);
						},
					},
					{
						field: "claim.datum",
						headerName: "Schadedatum",
						valueGetter: nestedValueGetter,
						//filterIgnoreCase: false,
						width: 150,
						sortable: false,
						filterable: false,
						renderCell: (params: GridRenderCellParams) => {
							return (
								<>
									{params.row.claim.datum &&
										moment(params.row.claim.datum).format("DD-MM-YYYY")}
								</>
							);
						},
					},

					{
						field: "policy.policyId",
						headerName: "PolisId",
						valueGetter: nestedValueGetter,
						width: 200,
						sortable: true,
					},

					{
						field: "policy.polnr",
						headerName: "Polisnr",
						valueGetter: nestedValueGetter,
						width: 150,
						sortable: true,
					},
					{
						field: "policy.kenteken",
						headerName: "Kenteken",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 150,
						sortable: true,
					},

					{
						field: "policy.relnr",
						headerName: "Relatienr",
						valueGetter: nestedValueGetter,
						width: 150,
						sortable: true,
					},
					{
						field: "customer.naam",
						headerName: "Naam",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 300,
						sortable: true,
					},
					{
						field: "customer.postcode",
						headerName: "Zipcode",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 300,
						sortable: true,
					}

				]}
				graphFunction={
					"claimsLookup"
				}
				rows={[]}
				getRowId={(item:any)=> item.claim.id}
				initialPageSize={10}
				rowsPerPageOptions={[5, 10, 20]}
				autoHeight={true}
				//disableColumnFilter
				//disableColumnMenu
				onRowClick={(params) => props.onRowClick && props.onRowClick(params.row)}
				autoSelectSingleRecord={props.autoSelectSingleRecord}
				onAutoSelect={(row) => props.onRowClick && props.onRowClick(row)}
			/>

		</Box>
	);
};
